var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.538,
    height: 57.613
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M62.038 1.547A28.9 28.9 0 0 1 53.4 6.202a11.56 11.56 0 0 0-13.7-3.79c-4.833 2.04-8 7.2-7.931 12.918v3.043C21.947 18.654 12.65 13.48 7 4.589c0 0-11 27.384 13.762 39.555A29.84 29.84 0 0 1 1.5 50.231c24.766 15.213 55.035 0 55.035-34.99a15 15 0 0 0-.22-2.525 24.2 24.2 0 0 0 5.723-11.169",
    "data-name": "Icon feather-twitter"
  })));
};
export default SvgTwitter;